import React from "react";

// Components
import Spacer from "../../Spacer";
import Text from "../../Text";
import css from "../Table.module.scss";

declare interface TableEmptyProps {
	emptyText: string;
	emptyChildren?: React.ReactNode;
}

const TableEmpty = ({ emptyText = "No Data", emptyChildren }: TableEmptyProps) => {
	return (
		<div className={`${css.tableBody} ${css.tableEmpty}`}>
			<Spacer height={14} />
			<Text size="paragraph-1" weight="semi-bold">
				{emptyText}
			</Text>
			{emptyChildren && (
				<div>
					<Spacer height={1} />
					{emptyChildren}
				</div>
			)}
			<Spacer height={14} />
		</div>
	);
};

export default TableEmpty;
